import React, { useState } from 'react';
import { AddCircleOutline, SwapVert } from '@mui/icons-material';
import { Button, Divider, Menu, MenuItem, Stack, Typography } from '@mui/material';
import {
  GET_CAREPLAN,
  GET_CAREPLAN_PRESCRIPTIONS,
  GET_CAREPLAN_SITE_GROUPS,
  MOVE_SITE_TO_PRESCRIPTION,
} from '../Queries';
import { useMutation } from '@apollo/client';
import { GET_PEER_REVIEW } from '../SidePanel/SidePanelQueries';

interface ButtonMenuProps {
  careplanId: string;
  siteId: string;
  prescriptionId: string;
  prescriptionIds: string[];
  disabled: boolean;
}

const MoveButton = ({
  careplanId,
  siteId,
  prescriptionId,
  prescriptionIds,
  disabled,
}: ButtonMenuProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [moveSiteToPrescription] = useMutation(MOVE_SITE_TO_PRESCRIPTION, {
    refetchQueries: [
      { query: GET_CAREPLAN_PRESCRIPTIONS, variables: { careplanId } },
      { query: GET_CAREPLAN_SITE_GROUPS, variables: { careplanId } },
      { query: GET_CAREPLAN, variables: { id: careplanId } },
      { query: GET_PEER_REVIEW, variables: { careplanId } },
    ],
  });
  const prescriptionIndicies = prescriptionIds
    .map((id, index) => (id !== prescriptionId ? index + 1 : null))
    .filter((index) => index !== null);
  return (
    <div>
      <Stack
        direction="row"
        alignItems="center"
        sx={{ cursor: 'pointer', padding: '8px 11px' }}
        gap={1}
        onClick={!disabled ? handleClick : undefined}>
        <SwapVert sx={{ color: !disabled ? 'text.primary' : 'text.disabled', ':hover': { fillOpacity: 0.75 } }} />
        <Typography variant="subtitle1" sx={{ color: !disabled ? 'text.primary' : 'text.disabled' }}>
          Move
        </Typography>
      </Stack>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem disabled>Move to</MenuItem>
        {prescriptionIndicies.map((id) => (
          <MenuItem
            key={id}
            onClick={() => {
              moveSiteToPrescription({ variables: { siteId, prescriptionId: prescriptionIds[id - 1] } });
            }}>
            Prescription {id}
          </MenuItem>
        ))}
        <Divider />
        <MenuItem
          onClick={() => {
            moveSiteToPrescription({ variables: { siteId, prescriptionId: null } });
          }}>
          <Stack direction="row" alignItems="center" gap={1}>
            <AddCircleOutline color="primary" />
            New Prescription
          </Stack>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default MoveButton;
